import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import moment from 'moment';
import fitSurvey2Services from '../../../../../services/fit-survey2.services';
import LegacySurveyForm from '../form/LegacySurveyForm';

const LegacySurveyModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: createLegacySurvey } =
    fitSurvey2Services.useMutationCreateLegacySurvey(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    });

  const { mutate: editLegacySurvey } =
    fitSurvey2Services.useMutationUpdateLegacySurvey(() => {
      queryClient.invalidateQueries({
        queryKey: ['get-legacy-survey2'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    });

  const _HandleSubmit = handleSubmit((data) => {
    const legaySurveyData = {
      title: data.title,
      description: data.description,
      imageUrl: data.imageUrl,
      isPopUp: data.isPopUp,
      point: data.point,
      startDate: moment(data.startDate).toDate(),
      endDate: moment(data.endDate).toDate(),
      display: true,
      memberType: data.memberType,
    };

    if (watch('formType') === 'create') {
      createLegacySurvey(legaySurveyData);
    } else if (watch('formType') === 'edit') {
      editLegacySurvey({ id: data.id, data: legaySurveyData });
    }
  });

  return (
    <Modal
      title={
        watch('formType') === 'create' ? 'เพิ่มแบบสอบถาม' : 'แก้ไขแบบสอบถาม'
      }
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacySurveyForm />
    </Modal>
  );
};

export default LegacySurveyModal;
